module.exports = __webpack_public_path__ + "img/companyIntro33.1d877943.png";